import app from './app';
import directCustomers from './directCustomers';
import { ORDER_SERVICE_URL, QUOTE_SERVICE_URL, ORDERS_SERVICE_URL } from '../../libs/constants';
import { saveAs } from 'file-saver';
import { delay } from '../../utils/utility';
import { format } from 'date-fns';

//POST
const createQuote = (userId, requestData, appMessages) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(QUOTE_SERVICE_URL + '/summary/' + userId, requestData)
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch({
                type: "SET_NEW_ORDER_QUOTE_CREATED",
                payload: {
                    quoteData: response.data,
                    appMessages: appMessages
                }
            });
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST
const saveQuote = (userId, requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(QUOTE_SERVICE_URL + "/" + userId, requestData)
        .then(response => {
            dispatch(app.setLoading(false));
            if (response.data.orderId) {
                dispatch({
                    type: "SET_NEW_ORDER_QUOTE_DATA",
                    payload: response.data
                });
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST
const createOrder = (requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "createOrder"
        }
    };

    await api.post(ORDER_SERVICE_URL, requestData, headerConfig)
        .then(response => {
            dispatch({
                type: "SET_NEW_ORDER_CREATED",
                payload: response.data
            });
            //requestData.userId && getOrdersSummary(requestData.userId);
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST
const getAllOrders = (searchConfig, userId, lspId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let url = ORDER_SERVICE_URL + "/list";
    if (userId) url += "/" + userId;

    const headerConfig = {
        headers: {
            ...(lspId) && { "lspId": lspId },
            "HW-Fetch-Type": "getAllOrders"
        }
    };

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data.orderList) {
                dispatch({
                    type: "SET_ORDER_LIST",
                    payload: { searchResultData: response.data, searchConfig: searchConfig }
                });
            }
            else {
                dispatch(setAPIFetchError(true));
                dispatch(setListRefreshed(true));
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(setAPIFetchError(true));
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const getAllOrdersList = (searchConfig) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let url = QUOTE_SERVICE_URL + "/list";
    //if (userId) url += "/" + userId;

    const headerConfig = {
        headers: {
            //...(lspId) && {"lspId": lspId},
            "DRS-Fetch-Type": "getAllOrdersList"
        }
    };

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data.orderList) {
                dispatch({
                    type: "SET_ORDER_LIST_DATA",
                    payload: response.data
                });
            }
            else {
                //dispatch(setAPIFetchError(true));
                //dispatch(setListRefreshed(true));
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            //dispatch(setAPIFetchError(true));
            //dispatch(app.setLoading(false));
            console.log(error);
        });
};

//GET
const getOrdersSummary = (userId, lspId) => async (dispatch, getState, api) => {

    const headerConfig = lspId ? {
        headers: {
            lspId: lspId,
        }
    } : null;

    let url = ORDER_SERVICE_URL + "/summary";
    if (userId) url += "/" + userId;

    await api.get(url, headerConfig)
        .then(response => {
            dispatch({
                type: "SET_ORDERS_SUMMARY",
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setOrderSummaryCallComplete(true));
        });
};

//POST
const getOrderIds = userId => async (dispatch, getState, api) => {
    await api.post(ORDER_SERVICE_URL + '/orderIdList/' + userId, {})
        .then(response => {
            dispatch({
                type: "SET_ORDER_IDS",
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST 
const downloadExcel = (requestData, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };

    let apiEndPointUrl = ORDER_SERVICE_URL + '/downloadExcel';
    if (userId) apiEndPointUrl += '/' + userId;

    await api.post(apiEndPointUrl, requestData, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), "Report.xlsx");
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST 
const downloadPdf = orderId => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let downloadConfig = {
        headers: {
            accept: "application/pdf"
        },
        responseType: "blob"
    };

    await api.post(ORDER_SERVICE_URL + '/downloadPdf/' + orderId, {}, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), orderId + ".pdf");
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//PATCH 
const cancelOrder = (orderId, requestData, showSuccessMessage, CB) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    //await api.patch(ORDER_SERVICE_URL + "orders/" + orderId + "/cancel")
    await api.post(ORDER_SERVICE_URL + "/" + orderId + "/cancel", requestData) // changed to support Akamai
        .then(response => {
            dispatch(app.setLoading(false));
            if (showSuccessMessage) {
                dispatch(app.setAppModal({ type: "info", messageId: "cancel_order_success" }));
            }
            CB && CB();
            dispatch({
                type: "SET_ORDER_STATUS",
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "cancel_order_error" }));
        });
};

//GET 
const getOrderDetails = (data) => async (dispatch, getState, api) => {
    //dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            ...(data.lspId) && { "lspId": data.lspId },
            ...(data.teamId) && { "teamId": data.teamId },
            "HW-Fetch-Type": "getOrderDetails"
        }
    };

    await api.get(ORDER_SERVICE_URL + "/" + data.orderId, headerConfig) // changed to support Akamai
        .then(response => {
            dispatch(app.setLoading(false));
            const payloadData = response.data.orderId ? response.data : null;

            dispatch({
                type: "SET_SELECTED_ORDER_DATA",
                payload: payloadData
            });
        })
        .catch(error => {
            dispatch({
                type: "SET_SELECTED_ORDER_DATA",
                payload: null
            });
            //dispatch(app.setLoading(false));
            //dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
        });
};


const getCTOrdersForDashboard = (userId, orderType) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const url = ORDER_SERVICE_URL + "/summary/" + userId + "?orderType=" + orderType;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getOrdersForDashboard"
        }
    };

    await api.post(url, {}, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_ORDERS_FOR_CT_DASHBOARD",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const getDCOrdersForDashboard = (userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const url = ORDER_SERVICE_URL + "/summary/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getOrdersForDCDashboard"
        }
    };

    await api.post(url, {}, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_ORDERS_FOR_DC_DASHBOARD",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const getDCOrdersForDashboardByFilter = (userId, filters) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const url = ORDER_SERVICE_URL + "/dasboard/directCustomer/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getOrdersForDCDashboardFilters"
        }
    };

    await api.post(url, { ...filters }, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_ORDERS_FOR_DC_DASHBOARD",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const downloadDashboardDetailCSV = (userId, filters) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const downloadConfig = {
        headers: {
            accept: "text/csv, application/csv, application/vnd.ms-excel"
        },
        responseType: "blob"
    };

    await api.post(ORDER_SERVICE_URL + '/downloadCsv/directcustomer/dashboard/' + userId, { ...filters }, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), `HPITAD_CustomerExtract_${format(new Date(), 'yyyyMMdd')}.csv`);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const downloadDashboardDetailJSON = (userId, filters) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const downloadConfig = {
        headers: {
            accept: "application/json"
        },
        responseType: "blob"
    };

    await api.post(ORDER_SERVICE_URL + '/downloadJson/directcustomer/' + userId, { ...filters }, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), `HPITAD_CustomerExtract_${format(new Date(), 'yyyyMMdd')}.json`);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getIDCDashboardValues = (userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const url = ORDER_SERVICE_URL + "/summary/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getIDCDashboardValues"
        }
    };

    await api.post(url, {}, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_VALUES_FOR_IDC_DASHBOARD",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};


//POST 
const downloadCertificate = (requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let downloadConfig = {
        headers: {
            accept: "application/" + requestData.format
        },
        responseType: "blob"
    };

    await api.post(ORDER_SERVICE_URL + '/downloadCert', requestData, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), requestData.name);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const uploadOrderFiles = (requestData, userId, { successHandler, rejectHandler }) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    await api.post(ORDER_SERVICE_URL + 'file/upload/' + userId, requestData, config)
        .then(response => {
            dispatch({
                type: "SET_NEW_ORDER_FILES_DATA",
                payload: response.data
            });
            dispatch(app.setLoading(false));

            if (response.data.orderFiles) {
                successHandler && successHandler(response.data.orderFiles);
            }
            else {
                rejectHandler && rejectHandler();
            }
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            rejectHandler && rejectHandler();
        });
}

const createOrderDispute = (userId, orderId, requestData, callback) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getOrderDetails" } };
        const response = await api.post(ORDER_SERVICE_URL + '/dispute/' + `${userId}/` + orderId, requestData, headerConfig);

        dispatch(app.setLoading(false));
        dispatch(app.closeAppModal());
        callback && callback();
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.closeAppModal());
    }
};

const getVendorFinancials = (userId, searchConfig) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let url = ORDER_SERVICE_URL + "/financialData/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getAllVendorFinancials"
        }
    };

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data.financialList) {
                dispatch({
                    type: "SET_MY_PAYMENTS_LIST",
                    payload: response.data
                });
            }
            else {
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error);
        });
};

const validateAFDelete = (userId, orderId) => async (dispatch, getState, api) => {
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "validateFinancialRecors"
        }
    };
    dispatch(app.setLoading(true));
    await api.get(ORDER_SERVICE_URL + '/validate/fincaicalrecords/' + userId + '/' + orderId, {}, headerConfig)
        .then(response => {
            dispatch({
                type: "SET_AF_REPORT_DELETE_VALID",
                payload: response.data
            })
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            dispatch(app.setLoading(false));
        });
};

const deleteAF = (userId, orderId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(ORDER_SERVICE_URL + '/delete/afReport/' + userId + '/' + orderId, {})
        .then(response => {
            dispatch(directCustomers.getDirectCustomerOrderDetails(userId, orderId));
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ open: false }));
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: "" }));
            dispatch(app.setLoading(false));
        });
    resetAFReportValidationFlag();
};

const resetAFReportValidationFlag = () => async (dispatch) => {
    dispatch({
        type: "SET_AF_REPORT_DELETE_VALID",
        payload: null
    })
}

const updateVendorFinancialData = (value, columnName, rowIndex) => {
    return {
        type: 'UPDATE_VENDOR_FINANCIAL_DATA',
        value,
        columnName,
        rowIndex
    }
};

const setListRefreshed = () => {
    return {
        type: 'SET_ORDER_LIST_REFRESHED',
    }
}

const setOrderSummaryCallComplete = isComplete => {
    return {
        type: 'SET_ORDER_SUMMARY_CALL_COMPLETE',
        data: isComplete
    }
}

const setAPIFetchError = isError => {
    return {
        type: 'SET_API_FETCH_ERROR',
        data: isError
    }
}

const setOrderDetailsCallComplete = isComplete => {
    return {
        type: 'SET_ORDER_DETAILS_CALL_COMPLETE',
        data: isComplete
    }
}

const setSearchConfig = configData => {
    return {
        type: 'SET_SEARCH_CONFIG',
        data: configData
    }
}

const resetSelectedOrderData = () => {
    return {
        type: 'RESET_SELECTED_ORDER_DATA'
    }
}

const orderActions = {
    createOrder: createOrder,
    getAllOrders: getAllOrders,
    getOrdersSummary: getOrdersSummary,
    setListRefreshed: setListRefreshed,
    setOrderSummaryCallComplete: setOrderSummaryCallComplete,
    downloadExcel: downloadExcel,
    downloadPdf: downloadPdf,
    cancelOrder: cancelOrder,
    getOrderDetails: getOrderDetails,
    downloadCertificate: downloadCertificate,
    setOrderDetailsCallComplete: setOrderDetailsCallComplete,
    setAPIFetchError: setAPIFetchError,
    resetSelectedOrderData: resetSelectedOrderData,
    getOrderIds: getOrderIds,
    createQuote: createQuote,
    saveQuote: saveQuote,
    setSearchConfig: setSearchConfig,
    uploadOrderFiles: uploadOrderFiles,
    getAllOrdersList,
    createOrderDispute: createOrderDispute,
    getCTOrdersForDashboard,
    getDCOrdersForDashboard,
    getDCOrdersForDashboardByFilter,
    downloadDashboardDetailCSV,
    downloadDashboardDetailJSON,
    getIDCDashboardValues,
    getVendorFinancials,
    updateVendorFinancialData,
    validateAFDelete,
    deleteAF,
    resetAFReportValidationFlag
}

export default orderActions;